import { render, staticRenderFns } from "./location-overview.vue?vue&type=template&id=979ffca8"
import script from "./location-overview.vue?vue&type=script&lang=ts"
export * from "./location-overview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLink: require('/vercel/path0/components/ui/link.vue').default,UiContainer: require('/vercel/path0/components/ui/container.vue').default})
